import { useEffect, useRef } from 'react';

export function usePreventPullToRefresh() {
  const startYRef = useRef(0);

  useEffect(() => {
    const { style: bodyStyle } = document.body;
    const { style: htmlStyle } = document.documentElement;

    const prevBody = bodyStyle.overscrollBehavior;
    const prevHtml = htmlStyle.overscrollBehavior;

    bodyStyle.overscrollBehavior = 'none';
    htmlStyle.overscrollBehavior = 'none';

    const onTouchStart = (e: TouchEvent) => {
      startYRef.current = e.touches[0]?.clientY ?? 0;
    };

    const onTouchMove = (e: TouchEvent) => {
      const y = e.touches[0]?.clientY ?? 0;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop <= 0 && y > startYRef.current) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });

    return () => {
      bodyStyle.overscrollBehavior = prevBody;
      htmlStyle.overscrollBehavior = prevHtml;
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
    };
  }, []);
}
